// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import Element from 'element-ui';

import './baseline.css';
import Layout from 'components/Layout';
import VssCard from 'components/VssCard';
import validate from 'utils/validate';
import componentCore from 'libs/componentCore';
import VueCompositionAPI from '@vue/composition-api';
import { mixin } from 'utils';

// mcfe组件库及其依赖
import '@mcfe/mcfe-components/lib/theme2/index.css';
import '@bfe/mtd-theme-582/index.css';
import MTD from '@ss/mtd-vue';
import mcfe from '@mcfe/mcfe-components';

import methodsPlugin from '../globalMethod/methodsPlugin';
import servicePlugin from '../services/servicePlugin';


import './vssSearchStyle.scss';

Vue.prototype.$EventBus = new Vue();

// 暂时按需引入项目中使用的mcfe组件所需的MTD组件。
Vue.use(mcfe);
Vue.use(MTD);

Vue.use(VueCompositionAPI);
Vue.use(Element);
Vue.use(mixin);
Vue.component('Layout', Layout);
Vue.component('XxLayout', Layout);
Vue.component('McLayout', Layout);
Vue.component('VssCard', VssCard);


Vue.use(componentCore);
Vue.use(methodsPlugin);
Vue.use(validate);
Vue.use(servicePlugin);

const $xxApiError = (e, customFn = (v) => v) => {
    Vue.prototype.$message.error(e && customFn((e.msg || e.message) || '系统请求异常'));
};

window.$xxApiError = $xxApiError;
Vue.prototype.$xxApiError = $xxApiError;


window.__requestErrorCallback = (e) => $xxApiError(e);
Vue.prototype.$s3Path = 'https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/';
